import { render, staticRenderFns } from "./CheckAcceptPackDrawer.vue?vue&type=template&id=2a04ffee&scoped=true"
import script from "./CheckAcceptPackDrawer.vue?vue&type=script&lang=js"
export * from "./CheckAcceptPackDrawer.vue?vue&type=script&lang=js"
import style0 from "./CheckAcceptPackDrawer.vue?vue&type=style&index=0&id=2a04ffee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04ffee",
  null
  
)

export default component.exports